import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';

export interface ICuiAlertDialogData {
  title: string;
  content: string;
  buttonLabel: string;
}

@Component({
  selector: 'cui-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class CuiAlertDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ICuiAlertDialogData) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/dialogs/alert-dialog/alert-dialog.component.ts